import { combineReducers } from 'redux'
import { CommonState, CommonReducer } from './common/common.reducer'
import { DashboardReducer, DashboardState } from './dashboard/dashboard.reducer'
import { HelpReducer, HelpState } from './help/help.reducer'
import { ImagesReducer, ImagesState } from './images/images.reducer'

export interface ApiError {
  // eslint-disable-next-line @typescript-eslint/ban-types
  [key: string]: Response | Error | {} | undefined
}

export interface CoreRootState {
  commonStore: CommonState
  dashboardStore: DashboardState
  imagesStore: ImagesState
  helpStore: HelpState
}

export const coreRootReducer = combineReducers<CoreRootState>({
  commonStore: CommonReducer,
  dashboardStore: DashboardReducer,
  imagesStore: ImagesReducer,
  helpStore: HelpReducer,
})
